import { useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import FlexChild from "layouts/flex/FlexChild";
import style from "./ContactUsModal.module.css";
import clsx from "classnames";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { isMobile } from "react-device-detect";
import emailjs from '@emailjs/browser';
import P from "layouts/wrapper/P";
import Dummy from "layouts/wrapper/Dummy";


const ContactUsSendingModal = NiceModal.create(
    (props, ref) => {
        const modal = useRef();
        const [withHeader, withFooter] = [true, true];
        const [width, height] = ["min(80%, 500px)", "30vh"];
        const withCloseButton = true;
        const clickOutsideToClose = true;
        const title = "고객문의";
        const buttonText = "확인";

        const [isSending, setSending] = useState(true);

        return (
            <ModalBase ref={modal} width={width} height={height} withHeader={withHeader} withFooter={withFooter} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} title={title} buttonText={buttonText}>
                <VerticalFlex>
                    <FlexChild justifyContent={"center"}>
                        <div>
                            {
                                props.isSending ?
                                    <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"}>고객님의 문의사항을 전송중입니다</P> :
                                    <>
                                        <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"}>성공적으로 전송했습니다</P>
                                        <Dummy height={10} />
                                        <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"}>담당자가 확인후 답변드리겠습니다</P>
                                        <Dummy height={10} />
                                        <P font={"Cafe24Ohsquareair"} size={"min(4vw, 15px)"}>저희 제품에 관심주신 고객님께 감사드립니다</P>
                                    </>
                            }
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </ModalBase>
        );
    }
);

export default ContactUsSendingModal;